import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      getTag_u4dqfb_k$(_this__u8e3s4, index) {
        return this.nested_cwsnxf_k$(this.elementName_p66hrm_k$(_this__u8e3s4, index));
      }
      nested_cwsnxf_k$(nestedName) {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        return this.composeName_8y2y4d_k$(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      elementName_p66hrm_k$(descriptor, index) {
        return descriptor.getElementName_u4sqmf_k$(index);
      }
      composeName_8y2y4d_k$(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      renderTagStack_rja478_k$() {
        return this.tagStack_1.isEmpty_y1axqb_k$() ? '$' : joinToString(this.tagStack_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.pushTag_bibnaf_k$(tag);
  var r = block();
  if (!$this.flag_1) {
    $this.popTag_g8zwqf_k$();
  }
  $this.flag_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.tagStack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.flag_1 = false;
      }
      get_serializersModule_piitvg_k$() {
        return EmptySerializersModule();
      }
      decodeTaggedValue_by1p0u_k$(tag) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      decodeTaggedNotNullMark_opj0f8_k$(tag) {
        return true;
      }
      decodeTaggedBoolean_172rbv_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      decodeTaggedByte_y3phtl_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedShort_dapzw9_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedInt_mhypkc_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedLong_y9rqqb_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      decodeTaggedFloat_81o7o9_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedDouble_aa801q_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedChar_w7yrsn_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return tmp instanceof Char() ? tmp.value_1 : THROW_CCE();
      }
      decodeTaggedString_45pp1e_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      decodeTaggedEnum_iouca9_k$(tag, enumDescriptor) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedInline_u4chc9_k$(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.pushTag_bibnaf_k$(tag);
        return this;
      }
      decodeSerializableValue_8i9jjz_k$(deserializer, previousValue) {
        return this.decodeSerializableValue_xpnpad_k$(deserializer);
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this.decodeTaggedInline_u4chc9_k$(this.popTag_g8zwqf_k$(), descriptor);
      }
      decodeNotNullMark_us4ba1_k$() {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.decodeTaggedNotNullMark_opj0f8_k$(currentTag);
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      decodeBoolean_m0aca_k$() {
        return this.decodeTaggedBoolean_172rbv_k$(this.popTag_g8zwqf_k$());
      }
      decodeByte_jzz7je_k$() {
        return this.decodeTaggedByte_y3phtl_k$(this.popTag_g8zwqf_k$());
      }
      decodeShort_jjqk32_k$() {
        return this.decodeTaggedShort_dapzw9_k$(this.popTag_g8zwqf_k$());
      }
      decodeInt_8iq8f5_k$() {
        return this.decodeTaggedInt_mhypkc_k$(this.popTag_g8zwqf_k$());
      }
      decodeLong_jzt186_k$() {
        return this.decodeTaggedLong_y9rqqb_k$(this.popTag_g8zwqf_k$());
      }
      decodeFloat_jcnrwu_k$() {
        return this.decodeTaggedFloat_81o7o9_k$(this.popTag_g8zwqf_k$());
      }
      decodeDouble_ur8l0f_k$() {
        return this.decodeTaggedDouble_aa801q_k$(this.popTag_g8zwqf_k$());
      }
      decodeChar_dcmcfa_k$() {
        return this.decodeTaggedChar_w7yrsn_k$(this.popTag_g8zwqf_k$());
      }
      decodeString_x3hxsx_k$() {
        return this.decodeTaggedString_45pp1e_k$(this.popTag_g8zwqf_k$());
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return this.decodeTaggedEnum_iouca9_k$(this.popTag_g8zwqf_k$(), enumDescriptor);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
      decodeBooleanElement_vuyhtj_k$(descriptor, index) {
        return this.decodeTaggedBoolean_172rbv_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeByteElement_c1pisz_k$(descriptor, index) {
        return this.decodeTaggedByte_y3phtl_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeShortElement_pzg12t_k$(descriptor, index) {
        return this.decodeTaggedShort_dapzw9_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeIntElement_941u6a_k$(descriptor, index) {
        return this.decodeTaggedInt_mhypkc_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeLongElement_994anb_k$(descriptor, index) {
        return this.decodeTaggedLong_y9rqqb_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeFloatElement_p2q55h_k$(descriptor, index) {
        return this.decodeTaggedFloat_81o7o9_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeDoubleElement_isei84_k$(descriptor, index) {
        return this.decodeTaggedDouble_aa801q_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeCharElement_frbao3_k$(descriptor, index) {
        return this.decodeTaggedChar_w7yrsn_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeStringElement_3oenpg_k$(descriptor, index) {
        return this.decodeTaggedString_45pp1e_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeInlineElement_s8883o_k$(descriptor, index) {
        return this.decodeTaggedInline_u4chc9_k$(this.getTag_u4dqfb_k$(descriptor, index), descriptor.getElementDescriptor_ncda77_k$(index));
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var tmp = this.getTag_u4dqfb_k$(descriptor, index);
        return tagBlock(this, tmp, () => this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue));
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        var tmp = this.getTag_u4dqfb_k$(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$();
          var tmp;
          if (isNullabilitySupported || this.decodeNotNullMark_us4ba1_k$()) {
            tmp = this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue);
          } else {
            tmp = this.decodeNull_jzrmuj_k$();
          }
          return tmp;
        });
      }
      get_currentTagOrNull_yhyzw_k$() {
        return lastOrNull(this.tagStack_1);
      }
      pushTag_bibnaf_k$(name) {
        this.tagStack_1.add_utx5q5_k$(name);
      }
      popTag_g8zwqf_k$() {
        var r = this.tagStack_1.removeAt_6niowx_k$(get_lastIndex(this.tagStack_1));
        this.flag_1 = true;
        return r;
      }
    }
    protoOf($).decodeSerializableElement$default_j0zaoi_k$ = decodeSerializableElement$default;
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    protoOf($).decodeSequentially_xlblqy_k$ = decodeSequentially;
    protoOf($).decodeCollectionSize_l3mlkk_k$ = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
